import 'reflect-metadata'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './app/store/store'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import ElementUI from 'element-ui'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
import { AppComponent } from './app/framework/di/AppComponents'
import 'normalize.css'
import '@/app/ui/styles/element-variables.scss'
import '@/app/ui/styles/index.scss'
import '@/app/ui/styles/_variables.scss'
import Editor from 'v-markdown-editor'
import '@/permission'
import moment from 'moment'
import Vuelidate from 'vuelidate'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SecureImage from '@/app/ui/components/SecureImage/index.vue'
import SecureLink from '@/app/ui/components/SecureLink/index.vue'

Vue.component('v-select', vSelect)
Vue.prototype.moment = moment
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(ElementUI)
Vue.use(Editor)
Vue.config.productionTip = false
Vue.component('tag-icon', Icon)
Vue.component('scrollbar', vueCustomScrollbar)
Vue.component('secure-image', SecureImage)
Vue.component('secure-link', SecureLink)
AppComponent.init()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
